import { Chip } from "@mui/material";
import styled from "styled-components";

export const StyledInputFieldContainer = styled.div`
    position: relative;
    font-family: heroregular;
`

export const StyledInputFieldLabel = styled.label`
    padding-right: 8px;
    padding-left: 8px;
    position:absolute;
    top:-12px;
    left:20px;
    /* Glass effect background */
    background: linear-gradient(135deg, rgba(49, 50, 56, 0.95) 0%, rgba(49, 50, 56, 0.9) 100%);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    color: rgba(255, 255, 255, 0.95);
    font-weight: 500;
    font-size: 16px;
    border-radius: 8px;
    z-index: 2;
    
    @media (min-width: 1280px) {
        font-size: 18px;
        top:-14px;
    }
    
    @media (max-width: 480px) {
        font-size: 14px;
        top:-10px;
        padding: 4px 6px;
    }
`

export const StyledInputField = styled.input`
    height: 56px;
    width: 100%;
    border-radius: 14px;
    /* Glass effect */
    background: ${props => 
        props?.disabled 
            ? 'linear-gradient(135deg, rgba(49, 50, 56, 0.6) 0%, rgba(49, 50, 56, 0.5) 100%)'
            : 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)'
    };
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    border: ${props => 
        props.disabled 
            ? '1px solid rgba(74, 75, 80, 0.5)' 
            : props.isValid 
                ? '1px solid rgba(255, 255, 255, 0.25)' 
                : '1px solid rgba(255, 0, 0, 0.5)'
    };
    padding: 0 18px;
    font-weight: 400;
    font-size: 18px;
    line-height: normal;
    letter-spacing: 0.5px;
    color: ${(props) => props.disabled ? 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 0.95)'};
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    
    &:focus {
        outline: none;
        border-color: ${props => props.disabled ? 'rgba(74, 75, 80, 0.7)' : 'rgba(255, 255, 255, 0.4)'};
        box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15), 0 0 0 3px rgba(255, 255, 255, 0.1);
        background: ${props => 
            props?.disabled 
                ? 'linear-gradient(135deg, rgba(49, 50, 56, 0.7) 0%, rgba(49, 50, 56, 0.6) 100%)'
                : 'linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%)'
        };
    }
    
    &:hover:not(:disabled) {
        border-color: rgba(255, 255, 255, 0.3);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    }
    
    @media (min-width: 1280px) {
        height: 60px;
        font-size: 20px;
        border-radius: 16px;
    }
    
    @media (max-width: 480px) {
        height: 50px;
        font-size: 16px;
        padding: 0 14px;
        border-radius: 12px;
    }
    
    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }
`

export const StyledChipContainer = styled.div`
    border: ${props => 
        props.disabled 
            ? '1px solid rgba(74, 75, 80, 0.5)' 
            : '1px solid rgba(255, 255, 255, 0.25)'
    };
    min-height: 56px;
    flex-flow: row wrap;
    display: flex;
    border-radius: 14px;
    /* Glass effect */
    background: ${props => 
        props?.disabled 
            ? 'linear-gradient(135deg, rgba(49, 50, 56, 0.6) 0%, rgba(49, 50, 56, 0.5) 100%)'
            : 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)'
    };
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    flex-direction: row;
    column-gap: 8px;
    padding: 12px 60px 8px 14px;
    align-items: center;
    position: relative;
    overflow-x: auto;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    
    &:hover:not([disabled]) {
        border-color: rgba(255, 255, 255, 0.3);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    }
    
    ::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;
    
    @media (min-width: 1280px) {
        min-height: 60px;
        border-radius: 16px;
        padding: 14px 60px 10px 18px;
    }
    
    @media (max-width: 480px) {
        min-height: 50px;
        border-radius: 12px;
        padding: 10px 50px 6px 12px;
        column-gap: 6px;
    }
`

export const ArrowInMultiSelect = styled.img`
    width: 30px;
    height: 30px;
    position: absolute;
    right: 20px;
    top: 15px;
    transition: all 0.3s ease-in-out;
    transform: ${props => props?.isClosed ? 'rotate(180deg)' : 'rotate(0deg)'};
`

export const StyledChip = styled(Chip)`
    background-color: ${props => props.disabled ? 'none' : '#FFFFFF !important'};
    border: 1px solid #FFF;
    font-size: 1rem !important;
    margin-bottom: 6px;
    opacity: ${props => props.disabled ? '1 !important' : 'inherit'};
    & .MuiChip-label {
        color: ${props => props.disabled ? '#FFF' : '#000'};
    }
`